import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client.js';
import type { Me, Tenant } from './types.js';

export function useMe() {
  return useQuery<Me>({
    queryKey: ['me'],
    queryFn: () => apiFetch<Me>('/me'),
    staleTime: 5 * 60_000,
  });
}

export function useTenants() {
  return useQuery<Tenant[]>({
    queryKey: ['tenants'],
    queryFn: () => apiFetch<Tenant[]>('/tenants'),
    staleTime: 5 * 60_000,
  });
}
